import React from "react";
import BasicBadgeImage from './basic_badge.png';
import DeletedAccountBadgeImage from './deleted_account_badge.png';

export const USER_TYPE_LIST = {
    student: '학생',
    teacher: '선생님',
    parent: '부모님',
    system_user: '독서길라잡이',
    system_admin: '독서길라잡이',
    author: '훈장님',
};

export type UserProfileInlineProps = {
    children?:React.ReactNode,
    id?:number;
    name?:string,
    type?:string,
    school?:string,
    image?:string,
    className?:string,
};

export const UserProfileInline = ({
  children,
  id,
  name,
  type,
  school,
  image,
  className,
}:UserProfileInlineProps) => {

  let imageUrl = image || BasicBadgeImage;
  if (id === null) imageUrl = DeletedAccountBadgeImage;

  return (
    <div className={`user-profile-inline ${className} fs-14`}>

      <img className="icon image p-r-1" src={imageUrl} alt="사용자 프로필 이미지" />

      <div>
        <div className="info">
          <strong className="fs-16">{name || "이용자"}</strong>
          {id === null && <span className="deleted_account">(탈퇴)</span>}
          { type && <span className={`user-type ${type}`}>{USER_TYPE_LIST[type]}</span> }
        </div>
        
        <div className="school fc-light-gray">
          { school && <p><i className="fa-solid fa-graduation-cap"></i> {school}</p> }
          { children }
        </div>
      </div>

    </div>
  );
};
